import type { SxProps, Theme } from "@mui/material/styles";

/** Container padrão das subseções da Gestão de comunicações (FluxZap). */
export const communicationsSubsectionPanelSx: SxProps<Theme> = {
  p: { xs: 1.25, sm: 1.5 },
  borderRadius: 2,
  bgcolor: "background.paper",
  borderColor: "divider",
};

/** Accordion das subseções (Insights): mesmo visual do Paper, com expansão. */
export const communicationsSubsectionAccordionSx: SxProps<Theme> = {
  borderRadius: 2,
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
  "&:before": { display: "none" },
  boxShadow: "none",
};

export const communicationsSubsectionAccordionSummarySx: SxProps<Theme> = {
  px: { xs: 1.25, sm: 1.5 },
  py: 1,
  minHeight: 56,
  "& .MuiAccordionSummary-content": {
    my: 0.5,
    alignItems: "flex-start",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "text.secondary",
  },
};

export const communicationsSubsectionAccordionDetailsSx: SxProps<Theme> = {
  px: { xs: 1.25, sm: 1.5 },
  pt: 0,
  pb: { xs: 1.25, sm: 1.5 },
};

/** Caixa do ícone no cabeçalho da subseção (espelha SectionHeader em escala menor). */
export const communicationsSubsectionIconBoxSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  borderRadius: 1.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  color: "primary.main",
  flexShrink: 0,
};

export const communicationsRankTableBodyCellSx = {
  textAlign: "center",
  verticalAlign: "middle",
} as const;

/** Toolbar interna dos cards de ranking (modelos / pacientes). */
export const communicationsRankTableToolbarSx: SxProps<Theme> = {
  px: 1.5,
  py: 1.25,
  borderBottom: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
};

/** Campo de busca filled alinhado a MessageTemplatesToolbar. */
export const communicationsRankFilledSearchFieldSx: SxProps<Theme> = {
  maxWidth: { md: 520 },
  "& .MuiFilledInput-root": {
    bgcolor: "neutral100.main",
  },
  // "& .MuiFilledInput-root:hover": {
  //   bgcolor: "background.paper",
  // },
  // "& .MuiFilledInput-root.Mui-focused": {
  //   bgcolor: "background.paper",
  // },
};

export interface CommunicationsRankRowSxOptions {
  /** 3px = seleção por checkbox; 4px = paciente com detalhe aberto. */
  borderWidth?: 3 | 4;
}

/** Destaque de linha nas tabelas de ranking (modelos ou pacientes). */
export function communicationsRankRowSx(
  isHighlighted: boolean,
  options?: CommunicationsRankRowSxOptions,
): SxProps<Theme> {
  const borderWidth = options?.borderWidth ?? 3;

  return isHighlighted
    ? {
        bgcolor: "primary100.main",
        borderLeft: `${borderWidth}px solid`,
        borderLeftColor: "primary.main",
        "& td": { fontWeight: 500 },
        "&:hover": { bgcolor: "primary200.main" },
      }
    : {
        "&:hover": { bgcolor: "action.hover" },
      };
}

/** @deprecated Use communicationsRankRowSx */
export const templateRankRowSx = communicationsRankRowSx;
